// extracted by mini-css-extract-plugin
export default {"root":"styles_root__s+Eoj","conversationDetailsModal":"styles_conversationDetailsModal__xmeZ-"};